import YumButton from '../YumButton/YumButton'
import React, { useState } from 'react'
import { t } from 'ttag'
import { CompanyId, DeleteFile$Request, FileDto, SaveImage$Request } from '../../services/api.types'
import { ReactComponent as UploadIcon } from '../../assets/v3/icons/announcements/upload.svg'
import { ReactComponent as LoadIcon } from './../../assets/icons/loader.svg'
import { Box } from '@material-ui/core'
import Loader from '../Loader/Loader'

export interface IYumUploadProps {
  companyId: CompanyId
  uploadedFileDto: FileDto | null
  existingImageDto: FileDto | null
  lastFileUploadFail: number | null
  updateUploadedImageDto(fileDto: FileDto | null): void
}

export interface IYumUploadDispatchProps {
  upload(payload: SaveImage$Request): void
  resetUploadedFileDto(): void
  deleteFile(payload: DeleteFile$Request): void
}

export const YumUpload = ({
  companyId,
  uploadedFileDto,
  existingImageDto,
  upload,
  lastFileUploadFail,
  resetUploadedFileDto,
  updateUploadedImageDto,
  deleteFile,
}: IYumUploadProps & IYumUploadDispatchProps) => {
  //const [fileDto, setFileDto] = useState(existingUrl)

  const [fileUrl, setFileUrl] = useState(existingImageDto ? existingImageDto.full : null)
  const [submitInProgress, setSubmitInProgress] = useState(false)

  const [isThumbImgLoading, setIsThumbImgLoading] = useState(true)

  const handleThumbImageLoad = () => {
    setIsThumbImgLoading(false)
  }

  const handleThumbImageError = () => {
    setIsThumbImgLoading(false)
  }

  React.useEffect(() => {
    setIsThumbImgLoading(true)
  }, [fileUrl])

  React.useEffect(() => {
    setFileUrl(existingImageDto ? existingImageDto.full : null)
  }, [existingImageDto])

  React.useEffect(() => {
    setSubmitInProgress(false)
  }, [lastFileUploadFail])

  React.useEffect(() => {
    if (uploadedFileDto && uploadedFileDto.full) {
      setFileUrl(uploadedFileDto.full)
      updateUploadedImageDto(uploadedFileDto)
      resetUploadedFileDto()
      setSubmitInProgress(false)
    }
  }, [uploadedFileDto])

  const handleDeleteImage = () => {
    //deleteFile({fileId: })
    setFileUrl(null)

    // TODO: This does not seem to update preview
    updateUploadedImageDto(null)
  }

  const fileInputRef = React.useRef<HTMLInputElement>(null)

  const handleUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (file) {
      setSubmitInProgress(true)
      upload({ file, companyId })
      if (fileInputRef.current) {
        fileInputRef.current.value = ''
      }
    }
  }

  return (
    <div style={{ marginBottom: '10px', display: 'flex', gap: '12px', alignItems: 'center', maxWidth: '100%' }}>
      {fileUrl && (
        <div style={{ position: 'relative', minWidth: '24px' }}>
          {isThumbImgLoading && (
            <div
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                marginLeft: '-12px',
                marginTop: '-12px',
              }}
            >
              <Loader noPadding={true} />
            </div>
          )}
          <img
            style={{ display: 'inline-block', maxWidth: '160px', position: 'relative', zIndex: 2 }}
            src={fileUrl}
            alt="Uploaded image"
            onLoad={handleThumbImageLoad}
            onError={handleThumbImageError}
          />
        </div>
      )}
      <div style={{ flex: 1 }}>
        <input
          onChange={handleUpload}
          accept=".png,.jpg,.jpeg,.tiff,.webp,.gif,.avif"
          id="contained-button-file"
          type="file"
          ref={fileInputRef}
          disabled={submitInProgress}
          style={{ display: 'none' }}
        />
        <label htmlFor="contained-button-file" style={{ display: 'inline-block', margin: '4px' }}>
          <YumButton variant="contained" color="primary" component="span" size="small" disabled={submitInProgress}>
            {submitInProgress ? (
              <Box
                sx={{
                  display: 'inline-block',
                  /* @ts-ignore */
                  '& path': {
                    fill: 'white',
                  },
                }}
              >
                <LoadIcon
                  style={{
                    position: 'relative',
                    width: '16px',
                    height: '16px',
                    marginRight: '8px',
                    marginTop: '-2px',
                    animationName: 'spin',
                    animationDuration: '1000ms',
                    animationIterationCount: 'infinite',
                    animationTimingFunction: 'linear',
                  }}
                />
              </Box>
            ) : (
              <UploadIcon style={{ marginTop: '-2px', marginRight: '8px' }} />
            )}
            {t`Upload image`}
          </YumButton>
        </label>
        {fileUrl && (
          <YumButton
            onClick={handleDeleteImage}
            variant="outlined"
            color="error"
            component="span"
            size="small"
            style={{ margin: '4px' }}
            disabled={submitInProgress}
          >
            {t`Delete`}
          </YumButton>
        )}
      </div>
    </div>
  )
}
